import { memo } from 'react';

import {
  QuestionStyled,
  QuestionWrapperStyled,
  HeroImageWrapper,
  HeroImageStyled,
  QuestionContentStyled,
  QuestionHeadingStyled,
  QuestionParagraphStyled,
  ButtonStyled
} from './styled/CallSalesCTASection';

const CallSalesCTASection = () => {
  const handleClickCall = () => {
    window.location.href = 'tel://+611300441593}';
  };

  return (
    <QuestionStyled>
      <QuestionWrapperStyled>
        <QuestionContentStyled>
          <QuestionHeadingStyled>Have questions?</QuestionHeadingStyled>
          <QuestionParagraphStyled>
            Our team of experts are here to help.
            Speak with a Sales Consultant today to
            find out how Oneflare can work for you.
          </QuestionParagraphStyled>
          <ButtonStyled
            onClick={handleClickCall}
            label="Call 1300 441 593"
          />
        </QuestionContentStyled>
        <HeroImageWrapper>
          <HeroImageStyled
            src="https://cdn.oneflare.com/static/client/reviews/have-questions-person.jpg"
            loading="lazy"
            alt="Review question image"
          />
        </HeroImageWrapper>
      </QuestionWrapperStyled>
    </QuestionStyled>
  );
};

export default memo(CallSalesCTASection);
